const app = {
  state: {
    VLanguage: localStorage.VLanguage || 'en-US',
    language: localStorage.appLanguage || 'en',
    primaryColor: localStorage.appPrimaryColor || '#1e2a5f',
    secondaryColor: localStorage.appSecondaryColor || '#0676ee'
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      var lng;
      switch (language) {
        case 'en':
          lng = 'en-US';
          break;
        case 'gr':
          lng = 'el-GR';
          break;
        case 'fr':
          lng = 'fr-FR';
          break;
        default:
          lng = 'en-US';
      }
      state.language = language;
      state.VLanguage = lng;
      localStorage.setItem('VLanguage', lng);
      localStorage.setItem('appLanguage', language);
      // location.reload()
    },
    SET_PRIMARY_COLOR: (state, primaryColor) => {
      if (primaryColor) {
        state.primaryColor = primaryColor;
        localStorage.setItem('appPrimaryColor', primaryColor);
        // console.log(state.primaryColor)
      }
    },
    SET_SECONDARY_COLOR: (state, secondaryColor) => {
      if (secondaryColor) {
        state.secondaryColor = secondaryColor;
        localStorage.setItem('appSecondaryColor', secondaryColor);
        // console.log(state.secondaryColor)
      }
    }
  },
  actions: {
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language);
    },
    setPrimaryColor ({ commit }, primaryColor) {
      commit('SET_PRIMARY_COLOR', primaryColor);
    },
    setSecondaryColor ({ commit }, secondaryColor) {
      commit('SET_SECONDARY_COLOR', secondaryColor);
    }
  },
  getters: {
    getMyLang: state => state.language
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js